module.exports = __webpack_public_path__ + "static/img/0541_8.5cc521f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/0541_8.jpg
// module id = wppR
// module chunks = 1